import LocalizedStringsModule, { LocalizedStringsMethods } from "localized-strings";
import de from "./de";
import en from "./en";

// Handle both CommonJS and ESM default exports
const LocalizedStrings = (LocalizedStringsModule as any).default || LocalizedStringsModule;

export type TranslationStrings = typeof de | typeof en;

type IStrings = LocalizedStringsMethods & TranslationStrings;

export const languages = {
  de,
  en,
};

export const translations: IStrings = new LocalizedStrings(languages, {
  customLanguageInterface: () => "en-En",
});

export const getStringsSave = (value: string) => {
  // eslint-disable-next-line @typescript-eslint/no-unsafe-call
  return translations.getString(value, translations.getLanguage(), true);
};

export default translations;

export const languageNames = {
  en: "English",
  de: "Deutsch",
};
